import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const actionTypes = {
  BRANCH_LIST: "BRANCH_LIST",
  ZONE_LIST: "ZONE_LIST",
  MEMBER_LIST: "MEMBER_LIST",
  LOADER: "LOADER",
  REFUND_LIST: "REFUND_LIST",
};

export const TeamLoader = () => {
  return {
    type: actionTypes.LOADER,
    teamloader: true,
  };
};


// Branch List
export const GetBranchList = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/ac/branch-list`, {
                params: { ...query },
                headers: {
                    "X-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.BRANCH_LIST,
                    BranchList: response.data,
                    teamloader: false,
                });
            })
            .catch((err) => {
                // console.log(err)
            });
    };
};

// Zone List
export const GetTeamZoneList = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/ac/get/zone`, {
                params: { ...query },
                headers: {
                    "X-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.ZONE_LIST,
                    ZoneList: response.data,
                    teamloader: false,
                });
            })
            .catch((err) => {
                // console.log(err)
            });
    };
};

// Member List
export const GetTeamMemberlist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/ac/member-list`, {
                params: { ...query },
                headers: {
                    "X-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.MEMBER_LIST,
                    MemberList: response.data,
                    teamloader: false,
                });
                // dispatch({ type: actionTypes.LOADER, teamloader: false });
            })
            .catch((err) => {
                // console.log(err)
                dispatch({ type: actionTypes.LOADER, teamloader: false });
            });
    };
};

// export team member list
export const ExportTeamMemberList = (query) => {

  const authToken = localStorage.getItem("Admin");
  const token = JSON.parse(authToken)?.data?.token;

  return async (dispatch) => {
    await axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/ac/memer-list/export`,
      {
        params: { ...query },
        headers: {
          "X-access-token": token,
        },
      })
      .then((response) => {
        toast.success(response.data.message, {
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          teamloader: false,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          teamloader: false,
        });
      });
  };
};

// Refund List
export const GetTeamRefundList = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;

    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/ac/refund-list`, {
                params: { ...query },
                headers: {
                    "X-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.REFUND_LIST,
                    RefundList: response.data,
                    teamloader: false,
                });
            })
            .catch((err) => {
                // console.log(err)
                dispatch({ type: actionTypes.LOADER, teamloader: false });
            });
    };
};

// export team refund list
export const ExportTeamRefundList = (query) => {

  const authToken = localStorage.getItem("Admin");
  const token = JSON.parse(authToken)?.data?.token;

  return async (dispatch) => {
    await axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/ac/refund-list/export`,
      {
        params: { ...query },
        headers: {
          "X-access-token": token,
        },
      })
      .then((response) => {
        toast.success(response?.data?.message, {
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          teamloader: false,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          theme: "colored",
          autoClose: 2000,
        });
        dispatch({
          type: actionTypes.LOADER,
          teamloader: false,
        });
      });
  };
};
